'use strict';
const angular = require('angular');

export class SideNavbarComponent {
 
  constructor($http, $state, $cookies, $scope, $rootScope, navService, $location, baseConfigService) {
    'ngInject';

    this.$state = $state;
    this.$http = $http;
    this.$scope = $scope;
    this.$location = $location;
    this.$rootScope = $rootScope;
 

    this.navService = navService;
    this.baseConfigService = baseConfigService;


  }

  $onInit(){
    // Get Nav 
    this.$scope.menu = this.navService.getSideBarNav();
    if(!this.$rootScope.page){
      this.$rootScope.page = _.filter(this.$scope.menu, {url: this.$location.path()})[0];
      console.log(this.$rootScope.page);
    }
    
   

  }
 /**
  * Set variable for page title, navigate to page url
  * @param {*} page 
  */
  gotoPage(page){
    console.log(page, " :: page")
    this.$location.url(`/?embedId=${page.url}`);
    this.loadIframe(page);
    console.log(this.$location.search());
    this.$scope.page = page;
    this.navService.setPage(page);

    
    console.log('sidebar: ', this.$scope.$root);
  }


loadIframe(params){
  var adminBaseURL = this.baseConfigService.getAdminBaseURL();
  var embedId = params.url;
  var $scope = this.$scope;

   //Get page details for title and description
  this.$scope.pageDetails = this.navService.getDetails(embedId);
  
    //Embed Iframe Function
     this.$http.get(`${adminBaseURL}/embed/tableau/${embedId}`)
       .then(function (response) {
         var embedInfo = response.data;
         console.log(embedInfo);
         $scope.title = embedInfo.name;
         $scope.token = embedInfo.token;
         document.getElementById('tableau-viz').token = embedInfo.token;
         document.getElementById('tableau-viz').src = embedInfo.url;
       
       })
       .catch(function (error) {
         console.log(error);
       })
}

  /**
   * Set page name and sub menu details
   * @param {*} subItem 
   * @param {*} item 
   */
  updateBreadcrumb(subItem, item){
    console.log(subItem);
    console.log(item);
    this.$rootScope.page = item;
    this.$rootScope.subItem = subItem;
    this.$location.url(subItem.url);
    this.showSubNav(item);
    this.subNavActive(item, subItem);
  }

  /**
   * Expand dropdown menu on page load if there are submenu items
   * @param {*} page 
   */
  showSubNav(page){
    this.$scope.menu.forEach(item => {
      if(item.title === page.title){
        item.expanded = true;
      } else {
        item.expanded = false;
      }
    });
  }

  /**
   * Set current sub menu link to active
   * @param {*} page 
   * @param {*} subItem 
   */
  subNavActive(page, subItem){
    console.log(page);
   if(page.subItem1){
    page.subItem1.forEach(subnav => {
      if(subnav.title === subItem.title){
        subnav.active = true;
      } else {
        subnav.active = false;
      }
    });
   }
  }
}

export default angular.module('appApp.sidebarnav', [])
  .directive('sidebarnav', function($rootScope) {
    return {
      template: require('./sidebarnav.html'),
      controller: SideNavbarComponent,
      controllerAs:'sidebarnavCtrl',
      restrict: 'EA',
      link: function(scope, element, attrs) {
        scope.$watch('page', function(){
          console.log($rootScope.page);
          scope.page = $rootScope.page;
        });
        scope.$watch('subItem', function(){
          console.log($rootScope.subItem);
          scope.subItem = $rootScope.subItem;
        })
      }
    };
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/directives/sidebarnav/sidebarnav.directive.js